import { render, staticRenderFns } from "./processAccidentDetail.vue?vue&type=template&id=e6c2be84"
import script from "./processAccidentDetail.vue?vue&type=script&lang=js"
export * from "./processAccidentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6c2be84')) {
      api.createRecord('e6c2be84', component.options)
    } else {
      api.reload('e6c2be84', component.options)
    }
    module.hot.accept("./processAccidentDetail.vue?vue&type=template&id=e6c2be84", function () {
      api.rerender('e6c2be84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/processAccidentDetail.vue"
export default component.exports